import { useLang } from "@/i18n/LanguageContext";
import { Quote } from "lucide-react";

const Testimonials = () => {
  const { t } = useLang();
  const items = t("testimonials.items");

  return (
    <section
      id="testimonials"
      data-testid="testimonials-section"
      className="relative bg-[#0e0e0e] py-24 md:py-32 border-t border-[#1f1f1f]"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="grid lg:grid-cols-12 gap-12 mb-14">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-3 mb-6">
              <span className="w-10 h-px bg-[#dc2626]" />
              <p className="font-mono text-xs tracking-[0.3em] uppercase text-[#dc2626]">
                {t("testimonials.tag")}
              </p>
            </div>
            <h2 className="font-display font-black uppercase tracking-tighter text-3xl md:text-5xl lg:text-6xl leading-[0.95]">
              {t("testimonials.heading")}
            </h2>
          </div>
        </div>

        <div className="grid md:grid-cols-3 gap-px bg-[#1f1f1f]">
          {items.map((q, i) => (
            <article
              key={i}
              data-testid={`testimonial-${i}`}
              className="bg-[#0e0e0e] p-8 md:p-10 flex flex-col"
            >
              <Quote className="w-8 h-8 text-[#dc2626] mb-6" />
              <p className="text-sm md:text-base text-[#d4d4d8] leading-relaxed mb-8">
                "{q.quote}"
              </p>
              <div className="mt-auto pt-6 border-t border-[#1f1f1f]">
                <p className="font-display font-bold uppercase tracking-tight text-sm md:text-base text-white">
                  {q.author}
                </p>
                <p className="font-mono text-[10px] tracking-[0.2em] uppercase text-[#71717a] mt-1">
                  {q.date}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
